import { useQuery } from "@tanstack/react-query";

import { listChats, listChatsRegistry, type ListChatsRegistryParams } from "./api";
import type { ChatListResponse, ChatRegistryResponse } from "./types";

/** Свежесть списков чатов (registry / по проекту / по workspace) — общая для всего домена. */
const CHAT_LIST_STALE_TIME_MS = 30_000;

export const chatListKey = (workspaceId?: string) =>
    ["v2", "chats", { workspaceId: workspaceId ?? "" }] as const;

export const chatRegistryKey = (params: ListChatsRegistryParams) =>
    ["v2", "chats", "registry", params] as const;

export function useChatsRegistry(params: ListChatsRegistryParams, options?: { enabled?: boolean }) {
    return useQuery<ChatRegistryResponse>({
        queryKey: chatRegistryKey(params),
        queryFn: () => listChatsRegistry(params),
        staleTime: CHAT_LIST_STALE_TIME_MS,
        enabled: options?.enabled ?? true,
    });
}

export function useChats(workspaceId?: string) {
    return useQuery<ChatListResponse>({
        queryKey: chatListKey(workspaceId),
        queryFn: () => listChats({ workspaceId, limit: 50 }),
        staleTime: CHAT_LIST_STALE_TIME_MS,
    });
}

export interface ChatsByProjectArgs {
    workspaceId: string | undefined;
    projectId: string;
    sceneId?: string;
}

export const chatsByProjectKey = ({ workspaceId, projectId, sceneId }: ChatsByProjectArgs) =>
    ["v2", "chats", { workspaceId: workspaceId ?? "", projectId, sceneId: sceneId ?? null }] as const;

export function useChatsByProject(args: ChatsByProjectArgs) {
    return useQuery<ChatListResponse>({
        queryKey: chatsByProjectKey(args),
        queryFn: () =>
            listChats({
                workspaceId: args.workspaceId,
                projectId: args.projectId,
                sceneId: args.sceneId,
                limit: 200,
                includeArchived: true,
            }),
        staleTime: CHAT_LIST_STALE_TIME_MS,
        enabled: !!args.workspaceId && !!args.projectId,
    });
}
